import { Link } from "react-router-dom";
import { Pill } from "lucide-react";
import SiteFooter from "@/components/SiteFooter";
import { LEGAL_VERSIONS } from "@/constants/legalContent";

export default function LegalLayout({ title, intro, children }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand text-white">
              <Pill className="h-4 w-4" />
            </span>
            <span className="font-display text-lg font-semibold tracking-tight">FindRxStaff</span>
          </Link>
          <Link to="/login" className="btn-ghost ml-auto" data-testid="legal-signin">
            Sign in
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <p className="overline">Legal</p>
        <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
        <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-sm text-slate-500" data-testid="legal-dates">
          <span>Effective Date: {LEGAL_VERSIONS.effective_date}</span>
          <span>Last Updated: {LEGAL_VERSIONS.last_updated}</span>
        </div>
        {intro && <p className="mt-6 text-base leading-relaxed text-slate-600">{intro}</p>}
        <div className="mt-10 space-y-9">{children}</div>
      </main>

      <SiteFooter />
    </div>
  );
}

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-xl font-semibold tracking-tight">{heading}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="space-y-1.5">
    {items.map((i) => (
      <li key={i} className="flex gap-2">
        <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-slate-400" />
        <span>{i}</span>
      </li>
    ))}
  </ul>
);
